// Shared identifiers for the twenty7tec OAuth "generate key" flow.
//
// The flow spans two browser tabs (the CRM tab and a short-lived OAuth tab), so
// these constants must be identical on both sides:
//   - main.ts            → the throwaway OAuth tab that catches ?code= at the root
//   - products.ts        → the CRM tab that opens the OAuth tab and receives the code
//
// Keep them in this one file so the two sides can never drift apart.

/**
 * sessionStorage flag set by the CRM tab right before it opens the OAuth tab.
 * sessionStorage is copied into the newly opened tab, so the OAuth tab can read
 * this to confirm "yes, this tab was opened by our generate-key flow" before it
 * relays the code back. The value stored is the caseId that started the flow.
 */
export const TWENTY7TEC_OAUTH_PENDING_KEY = 't27_oauth_pending';

/**
 * Marker on the postMessage payload so the CRM tab only reacts to messages that
 * came from our own OAuth tab (and ignores any other cross-window chatter).
 */
export const TWENTY7TEC_OAUTH_MESSAGE_SOURCE = 't27-oauth';
